/*******************************************************************************

  Project: Markenfels
  Author:  What.Digital
  Date:    05.2020

********************************************************************************

  1. Scroll to top
  2. Off canvas menu
  3. EU Cookie
  4. Dropdown Menu
  5. Lightbox for images and videos
  6. Responsive Videos
  7. Scoll Animations Init
  8. Object Fit Images
  9. Contact Form 7 Fix
  10. Accordion
  11. Map
  12. Equal Heights
  13. Footer fix
  14. Parallax
  15. Header
  16. Slider
  17. Scroll
  18. AJAX Load More
  19. Animations
  20. Video teaser
  21. Links

*******************************************************************************/

window.dataLayer = window.dataLayer || [];

jQuery( document ).ready(function($) {

/* 1. Scroll to top
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.c-scroll-to-top').addClass('show');
    } else {
      $('.c-scroll-to-top').removeClass('show');
    }
  });

  $('.c-scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

/* 2. Off canvas menu
------------------------------------------------------------------------------*/

  var $toggle = $('.js-menu-toggle');
  var $mobilePanel = $('.c-mobile-panel');
  var targetElement = document.querySelector('.c-mobile-panel');

  $toggle.on('click', function(e){
    e.preventDefault();
    if($('body').hasClass('disable-scroll')) {
      $('body').removeClass('disable-scroll');
      bodyScrollLock.clearAllBodyScrollLocks();
    }
    else {
      $('body').addClass('disable-scroll');
      bodyScrollLock.disableBodyScroll(targetElement);
      navbar.removeClass('-translate-y-full opacity-0').addClass('nav-down');
    }

    $mobilePanel.toggleClass('c-mobile-panel--is-active');
    $toggle.toggleClass('is-active');
  });

  $('ul.c-mob-menu li').has('ul').addClass('parentLi');
  $('ul.c-mob-menu li ul').addClass('sub-menu');

  $('ul.c-mob-menu .sub-menu').hide();

  $('ul.c-mob-menu .parentLi > a').on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('expanded');
    $(this).parent().find('ul.sub-menu').slideToggle();
  });

  // Hide navigation when user pressed Escape key on keyboard
  // $(document).on('keyup', function(e){
  //   if (e.keyCode === 27) {
  //     Nav.close();
  //   }
  // });

  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbar = $('.js-header');
  var navbarHeight = $('.js-header').outerHeight();

  $(window).scroll(function(event){
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 500);

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
      // Scroll Down
      navbar.removeClass('nav-down').addClass('-translate-y-full opacity-0');
    } else {
      // Scroll Up
      if(st + $(window).height() < $(document).height() && !(navbar.hasClass('page-nav-scrolling'))) {
        navbar.removeClass('-translate-y-full opacity-0').addClass('nav-down');
      }
    }

    lastScrollTop = st;
  }

/* 3. EU Cookie
------------------------------------------------------------------------------*/

  // Variables
  var expires_date = new Date('December 31, 2099 23:59:59');
  var cookie_notice_height = $('.cookie-bar').height();

  // Update variables and padding after screen resize
  $(window).on("debouncedresize", function( event ) {
    cookie_notice_height = $('.cookie-bar').height();
    if(!(Cookies.get('eu-cookie-law-markenfels') == 'accepted' || Cookies.get('eu-cookie-law-markenfels') == 'refused')) {
      $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    }
  });

  // Show cookie notice if it's not configured
  if(Cookies.get('eu-cookie-law-markenfels') == 'accepted' || Cookies.get('eu-cookie-law-markenfels') == 'refused') {
    $('body').removeClass('cookie-bar--not-decided');
  }
  else {
    $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    $('body').addClass('cookie-bar--not-decided');
  }

  // Hide cookie if it's accepted
  $('.js-accept-cookie').on('click', function(e){
    e.preventDefault();
    Cookies.set('eu-cookie-law-markenfels', 'accepted', { expires: expires_date });
    $('body').removeClass('cookie-bar--not-decided');
  });

  // Disable scripts and hide notice
  $('.js-refuse-cookie').on('click', function(e){
    e.preventDefault();
    if(theme_settings.cookie_popup == 1) {
      $.magnificPopup.open({
        items: {
            src: '<div class="white-popup">' + theme_settings.cookie_popup_text + '</div>',
            type: 'inline'
        },
        mainClass: 'mfp-with-fade',
        removalDelay: 160
      });
    }
    else {
      console.log('Tracking scripts and cookies are disabled.');
    }
    Cookies.set('eu-cookie-law-markenfels', 'refused', { expires: expires_date });
    // Opt out functions
    // doOptout();
    $('body').removeClass('cookie-bar--not-decided');
  });

/* 4. Dropdown Menu
------------------------------------------------------------------------------*/

  $('.c-hor-menu .menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });

  // Hide dropdown after click outside the menu
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.c-hor-menu .menu-item-has-children a').length) {
      $('.c-hor-menu .menu-item-has-children').removeClass('opened');
    }
  });

/* 5. Lightbox for images and videos
------------------------------------------------------------------------------*/

  $('a[href$=jpg], a[href$=jpeg], a[href$=jpe], a[href$=png], a[href$=gif]').magnificPopup({
    type: 'image',
    removalDelay: 500,
    mainClass: 'mfp-with-fade',
    closeOnContentClick: true,
    midClick: true
  });

  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-with-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
			patterns: {
        youtube: {
          index: 'youtube.com/',
          id: function(url) {
                  var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                  if ( !m || !m[1] ) return null;
                  return m[1];
              },
          src: '//www.youtube.com/embed/%id%?autoplay=1'
        },
				youtube_short: {
				  index: 'youtu.be/',
				  id: 'youtu.be/',
				  src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
				}
			}
		}
  });

/* 6. Responsive Videos
/*******************************************************************************/

  fitvids({
    // players: 'iframe[src*="example.com"]'
  });

/* 7. Scoll Animations Init
/*******************************************************************************/

  AOS.init({
    disable: 'mobile',
    once: true,
    duration: 1000,
  });

  window.addEventListener('load', AOS.refresh);

  function refreshAOS() {
    AOS.refresh();
  }

  $('img').on('load', _.throttle(refreshAOS, 1000));

/* 8. Object Fit Images
/*******************************************************************************/

  objectFitImages();

/* 9. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

/* 10. Accordion
/*******************************************************************************/

  // Hide all accordions
  var allPanels = $('.accordion dd').hide();
  var allTitles = $('.accordion dt');

  $('.accordion dt > a').click(function(e) {
  e.preventDefault();
  $this = $(this);
  $title = $this.parent();
  $target =  $this.parent().next();

  if(!$target.hasClass('accordion__text--active')){
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
    $target.addClass('accordion__text--active').slideDown();
    $title.addClass('accordion__subtitle--active');
  }
  else {
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
  }
  return false;
  });

/* 11. Map
/*******************************************************************************/

  $.each($('.dyn-map'), function(){

    var lat = $(this).data('lat');
    var long = $(this).data('long');
    var zoom = $(this).data('zoom');

    L.Icon.Default.imagePath = theme_settings.template_dir + '/assets/img/leaflet/';
    var mymap = new L.map($(this)[0], {
    scrollWheelZoom: false
    }).setView([lat, long], 16);

    // create custom icon
    var pinIcon = L.icon({
        iconUrl: theme_settings.template_dir + '/assets/img/leaflet/pin.svg',
        shadowUrl:  theme_settings.template_dir + '/assets/img/leaflet/marker-shadow.png',
        iconSize: [40, 50], // size of the icon
        iconAnchor:   [16, 50],
        shadowAnchor: [10, 39],
        popupAnchor:  [5, -48]
    });

    // Open Street Map - Wikimedia
    L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
        attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
        maxZoom: zoom
    }).addTo(mymap);

    if($(this).data('popup')) {
      L.marker([lat, long], {icon: pinIcon}).addTo(mymap)
      .bindPopup($(this).data('popup'))
      .openPopup();
    }

    // Open Street Map
    /*
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Open Street Map - Black and White
    /*
    L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Mapbox - remember to change accessToken
    /*
    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: zoom,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoiYWRhbXBpbGNoIiwiYSI6ImNqbTY0aGlzeTB0eTEza280dGVpcjVnemMifQ.zZjr5GSWWpe4lYGBjvuz1A'
    }).addTo(mymap);
    */

    mymap.on('click', function() {
    if (mymap.scrollWheelZoom.enabled()) {
      mymap.scrollWheelZoom.disable();
      }
      else {
      mymap.scrollWheelZoom.enable();
      }
    });

  });

/* 12. Equal Heights
------------------------------------------------------------------------------*/

  // Example:
  // $('.something').matchHeight();

  // Match Height compatibility with Lazy Load techniques
  function refreshMatchHeight() {
    $.fn.matchHeight._update();
  }
  $('img').on('load', _.throttle(refreshMatchHeight, 1000));

/* 13. Footer fix
------------------------------------------------------------------------------*/

  function fixFooter() {
    if($('body').outerHeight() < $(window).outerHeight()) {
      var footerHeight = $('.js-footer').outerHeight();
      var bodyHeight = $('body').outerHeight();
      var windowHeight = $(window).outerHeight();
      var contentHeight = bodyHeight - footerHeight;
      $('.js-footer').css('min-height', windowHeight - contentHeight + 'px');
    }
  }

  fixFooter();
  $(window).on("debouncedresize", function( event ) { fixFooter(); });

/* 14. Parallax
------------------------------------------------------------------------------*/

  window.onload = function() {
    lax.setup(); // init

    function updateLax(){
      lax.update(window.scrollY);
      window.requestAnimationFrame(updateLax);
    }

    window.requestAnimationFrame(updateLax);
  };

  /* 15. Header
  ------------------------------------------------------------------------------*/

    // Function which controls header status according to the distance from top
    function setHeaderStatus(scroll){
      if (scroll >= 1) { $('.c-header').addClass('c-header--scrolled'); }
      else {
        if(!($('body').hasClass('hc-nav-open'))) {
          $('.c-header').removeClass('c-header--scrolled');
        }
      }
    }

    // Set status on load
    setHeaderStatus($(window).scrollTop());

    // Set status during the scroll
    $(window).scroll(function() {
      setHeaderStatus($(window).scrollTop());
    });

/* 16. Slider
------------------------------------------------------------------------------*/

  var swiper = new Swiper('.swiper-container--style-slider', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 37,
    speed: 1000,
    touchEventsTarget: 'wrapper',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        recalculateSliderControls($(this.$el));
      },
    },
  });

  var swiperAlt = new Swiper('.swiper-container--style-carousel', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 37,
    speed: 1000,
    touchEventsTarget: 'wrapper',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        recalculateSliderControls($(this.$el));
      },
    },
  });

  $(window).on("debouncedresize", function( event ) {
    recalculateSliderControls($('.swiper-container'));
  });

  function recalculateSliderControls(slider) {
    var fistImageHeight = slider.find('img').height();
    var paginationTop = fistImageHeight + 52;
    slider.find('.swiper-pagination').css('top', paginationTop + 'px');
  }

/* 17. Download
------------------------------------------------------------------------------*/

  $('.c-circle__animated').circleProgress({
    value: 0,
    size: 130,
    thickness: 7,
    fill: '#28DC00',
    startAngle: -Math.PI/2,
    emptyFill: 'rgba(0, 0, 0, 0)',
    animation: { duration: 1500, easing: "circleProgressEasing" }
  });

  $('.c-circle__animated-mobile').circleProgress({
    value: 0,
    size: 88,
    thickness: 4,
    fill: '#28DC00',
    startAngle: -Math.PI/2,
    emptyFill: 'rgba(0, 0, 0, 0)',
    animation: { duration: 1500, easing: "circleProgressEasing" }
  });

  $('.c-circle').on('click', function(e){
    e.preventDefault();
    $(this).addClass('c-circle--clicked');
    $(this).find('.c-circle__animated').on('circle-animation-end',         function(event, progress) {
      var workingLink = $(this).closest('.c-circle').next()[0];
      workingLink.click();
      window.dataLayer.push({
        event: 'pdfLinkClicked',
        pdfLinkURL: $(workingLink).attr('href')
      });
    });

    $(this).find('.c-circle__animated').circleProgress('value', 1);
    $(this).find('.c-circle__animated-mobile').circleProgress('value', 1);
  });

/* 17. Scroll
------------------------------------------------------------------------------*/

  $('.js-scroll-to-content').on('click', function(e) {
    var target = $(this).closest('.l-wrap').find('.js-content');
    e.preventDefault();
    $.smoothScroll({
      scrollTarget: target,
      speed: 'auto'
    });
  });

  $('.js-scroll-to-archive').on('click', function(e) {
    var target = $(this).parent().find('.c-archive__item').first();
    e.preventDefault();
    $.smoothScroll({
      scrollTarget: target,
      speed: 'auto'
    });
  });

  if($('.c-page-nav').length > 0) {
    $('.c-page-nav a').smoothScroll({
      speed: 'auto',
      offset: parseInt($('.c-page-nav').offset().top - $(window).scrollTop()) * -1,
      beforeScroll: function() {
        navbar.addClass('page-nav-scrolling');
      },
      afterScroll: function() {
        setTimeout(function() {
          navbar.removeClass('page-nav-scrolling');
        }, 1000);
        // navbar.removeClass('page-nav-scrolling');
        // navbar.removeClass('nav-down').addClass('-translate-y-full opacity-0');
      }
    });
  }


  if($('#page-nav a').length > 0) {
    var spy = new Gumshoe('#page-nav a', {
      offset: parseInt($('.c-page-nav').offset().top - $(window).scrollTop())
    });
  }


/* 18. AJAX Load More
------------------------------------------------------------------------------*/

  var $loader = $('.js-load-more');

  $loader.on( 'click', load_ajax_posts );

  function load_ajax_posts() {

    var $content = $(this).closest('.block-ajax-load-more').find('.ajax_posts');
    var $content_place = $(this).closest('.block-ajax-load-more').find('.ajax_posts');

    var ppp = $(this).data('ppp');
    var offset = $(this).data('offset');
    var total_posts = $(this).data('total-posts');
    var post_type = $(this).data('post-type');
    var mode = $(this).data('mode');
    if(mode == 'one') {
      var cat = $(this).data('catid');
    }
    else {
      var cat = '';
    }
    if(mode == 'tag') {
      var tag = $(this).data('tagid');
    }
    else {
      var tag = '';
    }

    if (!($loader.hasClass('button--post-loading-loader') || $loader.hasClass('button--post-no-more-posts'))) {
      $.ajax({
        type: 'POST',
        dataType: 'html',
        url: theme_settings.ajaxurl,
        data: {
          'ppp': ppp,
          'offset': offset,
          'mode': mode,
          'catid': cat,
          'tagid': tag,
          'post_type': post_type,
          'action': 'theme_more_post_ajax',
        },
        beforeSend : function () {
          $loader.addClass('js-load-more--loading').find('span').html(theme_settings.loading);
        },
        success: function (data) {
          var tempScrollTop = $(window).scrollTop();
          var $data = $(data);
          if ($data.length) {
            var $newElements = $data.css({ opacity: 0 });
            $content_place.append($newElements);
            $newElements.animate({ opacity: 1 });
            if($content.find('.teaser').length < total_posts) {
              $loader.removeClass('js-load-more--loading').find('span.js-load-more__label').html(theme_settings.loadmore);
            }
            else {
              $loader.removeClass('js-load-more--loading').addClass('js-load-more--no-more-posts').find('span.js-load-more__label').html(theme_settings.noposts);
            }
            setHoverVideos();
          } else {
            $loader.removeClass('js-load-more--loading').addClass('js-load-more--no-more-posts').find('span.js-load-more__label').html(theme_settings.noposts);
          }
          $loader.data('offset', offset + ppp);
          if($loader.data('offset') >= $loader.data('total-posts')) {
            $loader.addClass('js-load-more--no-more-posts').find('span.js-load-more__label').html(theme_settings.noposts);
          }
          $(window).scrollTop(tempScrollTop);
          ScrollTrigger.refresh();
          addArrowsToLinks();
        },
        error : function (jqXHR, textStatus, errorThrown) {
          $loader.html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
          console.log(jqXHR);
        },
      });
    }
    return false;
  }

/* 19. Animations
------------------------------------------------------------------------------*/

  gsap.set('.a-animated', {'visibility' : 'visible'});

  gsap.registerPlugin(ScrollTrigger);

  document.addEventListener('lazyloaded', function(e){
    ScrollTrigger.refresh();
  });

  if($('.a-intro').length > 0) {
    var homeSectionIntroTL = gsap.timeline({
      scrollTrigger: "body",
      delay: 1
    })
    .from('.a-intro__mini-header', { opacity: 0, duration: 0.4, y: 10 })
    .from('.a-intro__header', { opacity: 0, duration: 0.4, y: 10 }, '>-0.1')
    .from('.a-intro__desc', { opacity: 0, duration: 0.4, y: 10 }, '>-0.1')
    .from('.a-intro__scroll', { opacity: 0, duration: 0.6, scale: 0.7, ease: "elastic.out(1, 0.75)" }, '>-0.1')
    .from('.c-section-intro-alt__content-line', { duration: 0.8, scaleY: 0, transformOrigin: "center top" }, '>-0.1')
    .from('.c-section-intro-alt__img', { opacity: 0, duration: 1.8 }, '>-0.2');
  }


  gsap.from('.a-header', {
    scrollTrigger: 'body',
      opacity: 0,
      duration: 1.2,
      y: '-100%',
      delay: 0.5
  });

  if($('.a-section-intro-block').length > 0) {
    var homeSectionIntroBlockTL = gsap.timeline({
      scrollTrigger: {
        trigger: '.a-section-intro-block',
        start: 'top 75%'
      }
    })
    .from('.a-section-intro-header', { opacity: 0, duration: 0.4, x: 10 })
    .from('.a-section-intro-link', { opacity: 0, duration: 0.4, x: 10 });
  }
  var circleDesktopTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.a-circle-desktop',
      start: 'top 75%',
      toggleActions: 'play none play none'
    }
  })
  .from('.a-circle-desktop .oval-red', { opacity: 0, duration: 1.5, scale: 0.5, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" })
  .from('.a-circle-desktop .oval-blue', { opacity: 0, duration: 1.5, scale: 0.5, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.4')
  .from('.a-circle-desktop .oval-black', { opacity: 0, duration: 1.5, scale: 0.5, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.4')
  .from('.a-circle-desktop .oval-grey', { opacity: 0, duration: 1.5, scale: 0.5, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.4')
  .from('.a-circle-desktop .c-anim-circle__label-1', { opacity: 0, duration: 0.8, x: -20 }, '>-1')
  .from('.a-circle-desktop .c-anim-circle__label-2', { opacity: 0, duration: 0.8, x: -20 }, '>-0.4')
  .from('.a-circle-desktop .c-anim-circle__label-3', { opacity: 0, duration: 0.8, x: -20 }, '>-0.4');

  gsap.utils.toArray('.wp-block-image').forEach(function(section) {
    gsap.from(section, {
      duration: 1,
      opacity: 0,
      y: 20,
      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
        toggleActions: 'play none play none'
      },
    });
  });

  gsap.from('.a-fade-up', {
    scrollTrigger: {
      trigger: 'a-fade-up',
      start: 'top 75%',
      toggleActions: 'play none play none'
    },
    opacity: 0,
    duration: 1.2,
    y: '10px'
  });

  gsap.utils.toArray(".a-line-dot").forEach(function(section) {
    var line = section.getElementsByClassName('c-line-dot__line');
    var dot = section.getElementsByClassName('c-line-dot__dot');
    gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
        toggleActions: 'play none play none'
      }
    })
    .from(line, { duration: 1, scale: 0, transformOrigin: 'center top'})
    .from(dot, { duration: 1, opacity: 0, scale: 0.5, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" });
  });

  gsap.set('#svg-infographic-1', {'visibility' : 'visible', 'opacity': '0'});

  // First part initial animation
  if($('#svg-infographic-1').length > 0) {
    var infographicEl = document.getElementById('svg-infographic-1');
    var infographicTL = gsap.timeline({
      scrollTrigger: infographicEl,
      toggleActions: 'play none play none'
    })
    .to(infographicEl, { duration: 1, opacity: 1, transformOrigin: "center center" })
    .from(document.getElementById('A_01_dot_strategic-consulting'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, 1)
    .from(document.getElementById('A_01_fade_strategic-consulting'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, 1)
    .from(document.getElementById('A_01_text_strategic-consulting'), { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(document.getElementById('A_02_dot_brand-analytics'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(document.getElementById('A_02_fade_brand-analytics'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(document.getElementById('A_02_text_brand-analytics'), { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(document.getElementById('ellipse-1'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1')
    .from(document.getElementById('circle-1'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1')
    .from(document.getElementById('A_03_dot_brand-strategy'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1')
    .from(document.getElementById('A_03_fade_brand-strategy'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(document.getElementById('A_03_text_brand-strategy'), { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(document.getElementById('A_04_dot_verbal-branding'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1')
    .from(document.getElementById('A_04_fade_verbal-branding'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(document.getElementById('A_04_text_verbal-branding'), { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(document.getElementById('A_05_dot_ma-branding'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1')
    .from(document.getElementById('A_05_fade_ma-branding'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(document.getElementById('A_05_text_ma-branding'), { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(document.getElementById('A_05_pulse_ma-branding'), { duration: 2, scale: 0.7, opacity: 0, ease: "elastic.out(1, 0.4)", transformOrigin: "center center" }, '>-1.2')
    .from(document.getElementById('circle-2'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(document.getElementById('A_06_dot_mgmt-consulting'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1')
    .from(document.getElementById('A_06_pulse_mgmt-consulting'), { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(document.getElementById('A_06_text_mgmt-consulting'), { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3');

    // Bordered circle + shadow - start animation
    // Brand analytics
    var brandAnalyticsDot = document.getElementById('A_02_dot_brand-analytics');
    var brandAnalyticsShadow = document.getElementById('A_02_fade_brand-analytics').getElementsByTagName('path')[0];

    var brandAnalyticsTimelineStart = gsap.timeline({ paused: true })

    .to(brandAnalyticsDot, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(brandAnalyticsShadow, { duration: 1.5, opacity: 1, scale: 1.5, transformOrigin: "center center" }, 0);

    $('#A_02_hoverbox_brand_analytics').hover(
      function(){ brandAnalyticsTimelineStart.play(0); },
      function(){ brandAnalyticsTimelineStart.reverse(); }
    );

    // Bordered circle + shadow - start animation
    // Verbal Branding
    var verbalBrandingDot = document.getElementById('A_04_dot_verbal-branding');
    var verbalBrandingShadow = document.getElementById('A_04_fade_verbal-branding').getElementsByTagName('path')[0];

    var verbalBrandingTimelineStart = gsap.timeline({ paused: true })

    .to(verbalBrandingDot, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(verbalBrandingShadow, { duration: 1.5, opacity: 1, scale: 1.5, transformOrigin: "center center" }, 0);

    $('#A_04_hoverbox_verbal-branding').hover(
      function(){ verbalBrandingTimelineStart.play(0); },
      function(){ verbalBrandingTimelineStart.reverse(); }
    );

    // Solid white dot + shadow - start animation
    // Brand Strategy
    var brandStrategyDot = document.getElementById('A_03_dot_brand-strategy');
    var brandStrategyShadow = document.getElementById('A_03_fade_brand-strategy').getElementsByTagName('path')[0];

    var brandStrategyTimelineStart = gsap.timeline({ paused: true })
    .to(brandStrategyDot, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(brandStrategyShadow, { duration: 2.5, scale: 2.5, opacity: 1, transformOrigin: "center center" }, '0');

    // Solid white dot + shadow - end animation
    var brandStrategyTimelineEnd = gsap.timeline({ paused: true })

    .to(brandStrategyDot, { duration: 1.5, scale: 1, transformOrigin: "center center" });

    $('#A_03_hoverbox_brand-strategy').hover(
      function(){ brandStrategyTimelineStart.play(0); },
      function(){ brandStrategyTimelineStart.reverse(); }
    );

    // Dot with border - animation start
    // Merger
    var mergerDot = document.getElementById('A_05_dot_ma-branding');
    var mergerBorder = document.getElementById('A_05_pulse_ma-branding');
    var mergerShadow = document.getElementById('A_05_fade_ma-branding').getElementsByTagName('path')[0];

    var mergerTimelineStart = gsap.timeline({ paused: true })

    .to(mergerDot, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(mergerBorder, { duration: 1.5, scale: 1.5, transformOrigin: "center center" }, 0)
    .to(mergerBorder, { duration: 1.5, scale: 2.5, opacity: 0, transformOrigin: "center center" }, '>-0.6')
    .to(mergerBorder, { duration: 1.5, scale: 0, opacity: 0, transformOrigin: "center center" })
    .to(mergerShadow, { duration: 1.5, scale: 1.5, opacity: 1, transformOrigin: "center center" }, 0);

    // Dot with border - animation start
    var mergerTimelineEnd = gsap.timeline({ paused: true })

    .to(mergerDot, { duration: 1.5, scale: 1, transformOrigin: "center center" })
    .to(mergerBorder, { duration: 1.5, scale: 1, opacity: 1, transformOrigin: "center center" }, 0)
    .to(mergerShadow, { duration: 1.5, scale: 1, opacity: 0, transformOrigin: "center center" }, 0);

    $('#A_05_hoverbox_ma-branding').hover(
      function(){ mergerTimelineStart.play(0); },
      function(){ mergerTimelineEnd.play(0); }
    );

    // Solid white dot + shadow - start animation
    // Management Consulting
    var managementConsultingDot = document.getElementById('A_06_dot_mgmt-consulting');
    var managementConsultingShadow = document.getElementById('A_06_pulse_mgmt-consulting').getElementsByTagName('path')[0];

    var managementConsultingTimelineStart = gsap.timeline({ paused: true })
    .to(managementConsultingDot, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(managementConsultingShadow, { duration: 2.5, scale: 2.5, opacity: 1, transformOrigin: "center center" }, '0');

    // Solid white dot + shadow - end animation
    var managementConsultingTimelineEnd = gsap.timeline({ paused: true })

    .to(managementConsultingDot, { duration: 1.5, scale: 1, transformOrigin: "center center" });

    $('#A_06_hoverbox_mgmt-consulting').hover(
      function(){ managementConsultingTimelineStart.play(0); },
      function(){ managementConsultingTimelineEnd.play(0); }
    );

  }



  gsap.set('#svg-infographic-2', {'visibility' : 'visible', 'opacity': '0'});

  // Second part initial animation
  if($('#svg-infographic-2').length > 0) {
    // Strategic Design
    var textStrategicDesign = document.getElementById('B_01_text_strategic-design');
    var dotStrategicDesign = document.getElementById('B_01_dot_strategic-design');
    var shadowStrategicDesign = document.getElementById('B_01_fade_strategic-design');

    // Corporate Design
    var textCorporateDesign = document.getElementById('B_02_text_corporate-design');
    var dotCorporateDesign = document.getElementById('B_02_dot_corporate-design');
    var shadowCorporateDesign = document.getElementById('B_02_fade_corporate-design');
    var triggerCorporateDesign = document.getElementById('B_02_hoverbox_corporate-design');

    // Digital Design
    var textDigitalDesign = document.getElementById('B_03_text_digital-design');
    var dotDigitalDesign = document.getElementById('B_03_dot_digital-design');
    var shadowDigitalDesign = document.getElementById('B_03_fade_digital-design');
    var triggerDigitalDesign = document.getElementById('B_03_hoverbox_digital-design');

    // Spatial Design
    var textSpatialDesign = document.getElementById('B_04_text_spatial-design');
    var dotSpatialDesign = document.getElementById('B_04_dot_spatial-design');
    var shadowSpatialDesign = document.getElementById('B_04_fade_spatial-design');
    var triggerSpatialDesign = document.getElementById('B_04_hoverbox_spatial-design');

    // Employer Branding
    var textEmployerBranding = document.getElementById('B_05_text_employer-branding');
    var dotEmployerBranding  = document.getElementById('B_05_dot_employer-branding');
    var shadowEmployerBranding  = document.getElementById('B_05_fade_employer-branding');
    var triggerEmployerBranding = document.getElementById('B_05_hoverbox_employer-branding');

    // Brand Refresh
    var textBrandRefresh = document.getElementById('B_06_text_brand-refresh');
    var dotBrandRefresh  = document.getElementById('B_06_dot_brand-refresh');
    var borderBrandRefresh  = document.getElementById('B_06_pulse_brand-refresh');
    var shadowBrandRefresh  = document.getElementById('B_06_fade_brand-refresh');
    var triggerBrandRefresh = document.getElementById('B_06_hoverbox_brand-refresh');

    var infographicEl2 = document.getElementById('svg-infographic-2');
    var infographicTL2 = gsap.timeline({
      scrollTrigger: infographicEl2,
      toggleActions: 'play none play none'
    })
    .to(infographicEl2, { duration: 1, opacity: 1, transformOrigin: "center center" })
    .from(dotStrategicDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, 1)
    .from(shadowStrategicDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textStrategicDesign, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotCorporateDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowCorporateDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textCorporateDesign, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotDigitalDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowDigitalDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textDigitalDesign, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotSpatialDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowSpatialDesign, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textSpatialDesign, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotEmployerBranding, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowEmployerBranding, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textEmployerBranding, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotBrandRefresh, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowBrandRefresh, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(borderBrandRefresh, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textBrandRefresh, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3');

    var corporateDesignTimelineStart = gsap.timeline({ paused: true })
    .to(dotCorporateDesign, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowCorporateDesign, { duration: 2.5, scale: 2.5, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerCorporateDesign).hover(
      function(){ corporateDesignTimelineStart.play(0); },
      function(){ corporateDesignTimelineStart.reverse(); }
    );

    var digitalDesignTimelineStart = gsap.timeline({ paused: true })
    .to(dotDigitalDesign, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowDigitalDesign, { duration: 1, scale: 1.5, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerDigitalDesign).hover(
      function(){ digitalDesignTimelineStart.play(0); },
      function(){ digitalDesignTimelineStart.reverse(); }
    );

    var spatialDesignTimelineStart = gsap.timeline({ paused: true })
    .to(dotSpatialDesign, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowSpatialDesign, { duration: 1, scale: 1.5, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerSpatialDesign).hover(
      function(){ spatialDesignTimelineStart.play(0); },
      function(){ spatialDesignTimelineStart.reverse(); }
    );

    var employerBrandingTimelineStart = gsap.timeline({ paused: true })
    .to(dotEmployerBranding, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowEmployerBranding, { duration: 1, scale: 1.5, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerEmployerBranding).hover(
      function(){ employerBrandingTimelineStart.play(0); },
      function(){ employerBrandingTimelineStart.reverse(); }
    );

    // Brand Refresh
    var brandRefreshTimelineStart = gsap.timeline({ paused: true })

    .to(dotBrandRefresh, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(borderBrandRefresh, { duration: 1.5, scale: 1.5, transformOrigin: "center center" }, 0)
    .to(borderBrandRefresh, { duration: 1.5, scale: 2.5, opacity: 0, transformOrigin: "center center" }, '>-0.6')
    .to(borderBrandRefresh, { duration: 1.5, scale: 0, opacity: 0, transformOrigin: "center center" })
    .to(shadowBrandRefresh, { duration: 1.5, scale: 1.5, opacity: 1, transformOrigin: "center center" }, 0);

    // Dot with border - animation start
    var brandRefreshTimelineEnd = gsap.timeline({ paused: true })

    .to(dotBrandRefresh, { duration: 1.5, scale: 1, transformOrigin: "center center" })
    .to(borderBrandRefresh, { duration: 1.5, scale: 1, opacity: 1, transformOrigin: "center center" }, 0)
    .to(shadowBrandRefresh, { duration: 1.5, scale: 1, opacity: 0, transformOrigin: "center center" }, 0);

    $(triggerBrandRefresh).hover(
      function(){ brandRefreshTimelineStart.play(0); },
      function(){ brandRefreshTimelineStart.reverse(); }
    );

  }

  gsap.set('#svg-infographic-3', {'visibility' : 'visible', 'opacity': '0'});

  // Second part initial animation
  if($('#svg-infographic-3').length > 0) {
    // Strategic Activation
    var textStrategicActivation = document.getElementById('C_01_text_strategic-activation');
    var dotStrategicActivation = document.getElementById('C_01_dot_strategic-activation');
    var shadowStrategicActivation = document.getElementById('C_01_fade_strategic-activation');

    // Brand Experience
    var textBrandExperience = document.getElementById('C_02_text_brand-experience');
    var dotBrandExperience = document.getElementById('C_02_dot_brand-experience');
    var shadowBrandExperience = document.getElementById('C_02_fade_brand-experience');
    var triggerBrandExperience = document.getElementById('C_02_hoverbox_brand-experience');

    // Brand Rollout
    var textBrandRollout = document.getElementById('C_03_text_brand-rollout');
    var dotBrandRollout = document.getElementById('C_03_dot_brand-rollout');
    var shadowBrandRollout = document.getElementById('C_03_fade_brand-rollout');
    var triggerBrandRollout = document.getElementById('C_03_hoverbox_brand-rollout');

    // Brand Management
    var textBrandManagement = document.getElementById('C_04_text_brand-mgmt');
    var dotBrandManagement  = document.getElementById('C_04_dot_brand-mgmt');
    var borderBrandManagement  = document.getElementById('C_04_pulse_brand-mgmt');
    var shadowBrandManagement  = document.getElementById('C_04_fade_brand-mgmt');
    var triggerBrandManagement = document.getElementById('C_04_hoverbox_brand-mgmt');

    // Brand Engagement
    var textBrandEngagement = document.getElementById('C_05_text_brand-engagement');
    var dotBrandEngagement  = document.getElementById('C_05_dot_brand-engagement');
    var shadowBrandEngagement  = document.getElementById('C_05_fade_brand-engagement');
    var triggerBrandEngagement = document.getElementById('C_05_hoverbox_brand-engagement');

    //gsap.set(shadowBrandEngagement, {'opacity': '0', 'scale': '1.5'});

    var infographicEl3 = document.getElementById('svg-infographic-3');
    var infographicTL3 = gsap.timeline({
      scrollTrigger: infographicEl3,
      toggleActions: 'play none play none'
    })
    .to(infographicEl3, { duration: 1, opacity: 1, transformOrigin: "center center" })
    .from(dotStrategicActivation, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, 1)
    .from(shadowStrategicActivation, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textStrategicActivation, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotBrandExperience, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowBrandExperience, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textBrandExperience, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotBrandRollout, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowBrandRollout, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textBrandRollout, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotBrandManagement, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(borderBrandManagement, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(shadowBrandManagement, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textBrandManagement, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3')
    .from(dotBrandEngagement, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-0.6')
    .from(shadowBrandEngagement, { duration: 1.5, scale: 0.5, opacity: 0, ease: "elastic.out(1, 0.5)", transformOrigin: "center center" }, '>-1.5')
    .from(textBrandEngagement, { duration: 1, opacity: 0, x: -30, transformOrigin: "center center" }, '>-1.3');

    var brandEngagementTimelineStart = gsap.timeline({ paused: true })
    .to(dotBrandEngagement, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowBrandEngagement, { duration: 2.5, scale: 2, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerBrandEngagement).hover(
      function(){ brandEngagementTimelineStart.play(0); },
      function(){ brandEngagementTimelineStart.reverse(); }
    );

    var brandExperienceTimelineStart = gsap.timeline({ paused: true })
    .to(dotBrandExperience, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowBrandExperience, { duration: 1, scale: 1.5, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerBrandExperience).hover(
      function(){ brandExperienceTimelineStart.play(0); },
      function(){ brandExperienceTimelineStart.reverse(); }
    );

    var brandRolloutTimelineStart = gsap.timeline({ paused: true })
    .to(dotBrandRollout, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(shadowBrandRollout, { duration: 1, scale: 1.5, opacity: 1, transformOrigin: "center center" }, '<');

    $(triggerBrandRollout).hover(
      function(){ brandRolloutTimelineStart.play(0); },
      function(){ brandRolloutTimelineStart.reverse(); }
    );

    var brandManagementTimelineStart = gsap.timeline({ paused: true })

    .to(dotBrandManagement, { duration: 1.5, scale: 1.5, transformOrigin: "center center" })
    .to(borderBrandManagement, { duration: 1.5, scale: 1.5, transformOrigin: "center center" }, 0)
    .to(borderBrandManagement, { duration: 1.5, scale: 2.5, opacity: 0, transformOrigin: "center center" }, '>-0.6')
    .to(borderBrandManagement, { duration: 1.5, scale: 0, opacity: 0, transformOrigin: "center center" })
    .to(shadowBrandManagement, { duration: 1.5, scale: 1.5, opacity: 1, transformOrigin: "center center" }, 0);

    $(triggerBrandManagement).hover(
      function(){ brandManagementTimelineStart.play(0); },
      function(){ brandManagementTimelineStart.reverse(); }
    );
  }

/* 20. Video teaser
------------------------------------------------------------------------------*/

  function setHoverVideos() {
    if($('.c-video-teaser__video').length > 0) {
      var mq = window.matchMedia( "(min-width: 1200px)" );
      if (mq.matches) {

        $('.c-video-teaser__video').each(function( index ) {
          $(this).coverVid(595, 334);
        });

        $('.c-video-teaser--hover').closest('a')
          .on('mouseenter', function(){
            $(this).find('.c-video-teaser__img').addClass('c-video-teaser__img--hidden');
            $(this).find('video').first()[0].play();
          })
          .on('mouseleave', function(){
            $(this).find('video').first()[0].pause();
          });
          $('.c-video-teaser--toggle')
          .on('mouseenter', function(){
            $(this).find('.c-video-teaser__img').addClass('c-video-teaser__img--hidden');
            $(this).find('video').first()[0].play();
          })
          .on('mouseleave', function(){
            $(this).find('video').first()[0].pause();
          });

          $( '.c-video-teaser--always' ).each(function( index ) {
            $(this).find('.c-video-teaser__img').addClass('c-video-teaser__img--hidden');
            $(this).find('video').first()[0].play();
          });
      }
      else {
        $('.c-video-teaser__video').hide();
      }
    }
  }

  setHoverVideos();

/* 21. Links
------------------------------------------------------------------------------*/

  $('.c-link-external').each(function(index){
    $(this).append('<svg class="arrow-icon icon-normal" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#28DC00" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M15.19,10.68H11.3A2.3,2.3,0,0,0,9,13V20.7A2.3,2.3,0,0,0,11.3,23h7.77a2.3,2.3,0,0,0,2.3-2.3V16.64m2-3.58V8.65M19,8.64H23.4M16,16l7.34-7.34" transform="translate(-0.13 -0.13)" fill="none" stroke="#000000" stroke-linecap="round" stroke-width="1.5"/></g></svg><svg class="icon-hover arrow-icon-hover" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#28DC00" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M15.19,10.68H11.3A2.3,2.3,0,0,0,9,13V20.7A2.3,2.3,0,0,0,11.3,23h7.77a2.3,2.3,0,0,0,2.3-2.3V16.64m2-3.58V8.65M19,8.64H23.4M16,16l7.34-7.34" transform="translate(-0.13 -0.13)" fill="none" stroke="#28DC00" stroke-linecap="round" stroke-width="1.5"/></g></svg>');
  });

  $('.c-link-download').each(function(index){
    $(this).append('<svg class="arrow-icon icon-normal" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#28DC00" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M10.84,14.17,16,19.32m5.16-5.15L16,19.32M16,8V19.26m-5.18,3.67H21.2" transform="translate(-0.13 -0.13)" fill="none" stroke="#000000" stroke-linecap="round" stroke-width="1.5"/></g></svg><svg class="arrow-icon icon-hover" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#28DC00" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M10.84,14.17,16,19.32m5.16-5.15L16,19.32M16,8V19.26m-5.18,3.67H21.2" transform="translate(-0.13 -0.13)" fill="none" stroke="#28DC00" stroke-linecap="round" stroke-width="1.5"/></g></svg>');
  });

  function addArrowsToLinks() {
    $('.c-link-arrow:not(.c-link-arrow--with-icon-added)').each(function(index){
      $(this).append('<svg class="arrow-icon icon-normal" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#28DC00" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M18.64,21.19,23.82,16m-5.18-5.19L23.82,16M6.53,16H23.76" transform="translate(-0.13 -0.13)" fill="none" stroke="#000000" stroke-linecap="round" stroke-width="1.5"/></g></svg><svg class="arrow-icon-hover icon-hover" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#28DC00" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M18.64,21.19,23.82,16m-5.18-5.19L23.82,16M6.53,16H23.76" transform="translate(-0.13 -0.13)" fill="none" stroke="#28DC00" stroke-linecap="round" stroke-width="1.5"/></g></svg>');
      $(this).addClass('c-link-arrow--with-icon-added');
    });
  }

  addArrowsToLinks();


/* Animated Counter
------------------------------------------------------------------------------*/

$(".counter").countimator();

$('.svg-animated').each(function(){
  new Vivus(this, {
    duration: 75,
    type: 'delayed',
    start: 'inViewport'
  });
});

/* Smooth scroll
------------------------------------------------------------------------------*/

if ($('.glossary-letters').length > 0) {
  $('a[href^="#"]').on('click', function (event) {
    event.preventDefault(); // Prevents the default link behavior

    var target = $(this.getAttribute('href')); // Gets the target element based on href

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top // Smoothly scrolls to the target element
      }, 1000); // Animation duration in milliseconds
    }
  });
}

/* Popups
------------------------------------------------------------------------------*/

  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,
    focus: '#username',
    modal: true
  });

  $(document).on('click', '.close', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

/* Dynamic Popups with forms
------------------------------------------------------------------------------*/

  const pdfForms = document.querySelectorAll('.js-dynamic-attachment-form');

  pdfForms.forEach(pdfForm => {
    const attachmentPath = pdfForm.getAttribute('data-attachment-path');
    const attachmentName = pdfForm.getAttribute('data-attachment-name');
    const emailTitle = pdfForm.getAttribute('data-email-title');
    const emailFirstParagraph = pdfForm.getAttribute('data-email-first-paragraph');

    const form = pdfForm.querySelector('form');

    if (form) {
      const attachmentPathField = form.querySelector('input[name="emailattachment"]');
      const attachmentNameField = form.querySelector('input[name="emailattachmentname"]');
      const emailTitleField = form.querySelector('input[name="emailtitle"]');
      const emailFirstParagraphField = form.querySelector('input[name="emailparagraph"]');

      if (attachmentPath && attachmentPathField) {
        attachmentPathField.value = attachmentPath;
      }

      if (attachmentName && attachmentNameField) {
        attachmentNameField.value = attachmentName;
      }

      if (emailTitle && emailTitleField) {
        emailTitleField.value = emailTitle;
      }

      if (emailFirstParagraph && emailFirstParagraphField) {
        emailFirstParagraphField.value = emailFirstParagraph;
      }
    }
  });

  // Hide the form and headline if the form has .form-fields-wrap element inside and the form was successfully submitted
  document.addEventListener('wpcf7mailsent', function (event) {
    const formID = event.detail.unitTag;
    const formElement = document.querySelector(`#${formID}`);

    if (formElement) {
      const formFieldsWrap = formElement.querySelector('.form-fields-wrap');
      if (formFieldsWrap) {
        formFieldsWrap.style.display = 'none';
      }
      const headerAboveTheForm = formElement.parentElement.querySelector('.c-headline');
      if (headerAboveTheForm) {
        headerAboveTheForm.style.display = 'none';
      }
    }
  }, false);

}); // end of jQuery code
